//NODE MODULES
import { useEffect, useRef } from "react";

//KPP COMPONENTS
import LinkImage from "../helpers/LinkImage";

//CONFIG
import { navRoutes } from "../../config/nav";

//ASSETS
import featureImg_01 from "../../assets/img/hero/feature-01.jpg";
import featureImg_02 from "../../assets/img/hero/feature-02.jpg";
import featureImg_03 from "../../assets/img/hero/feature-03.jpg";
import featureImg_04 from "../../assets/img/hero/feature-04.jpg";
import featureImg_05 from "../../assets/img/hero/feature-05.jpg";
import aboutImg from "../../assets/img/hero/about.jpg";
import contactImg from "../../assets/img/hero/contact.jpg";
import NewsSlider from "./NewsSlider";

let activeIndex = 0;
let activeIndexPrev = activeIndex;
let imageTotalIndex = 4; //Minus 1 from image count
let zIndexCounter = 1;

const Hero = () => {
	const intervalRef = useRef(null);

	// useEffect(() => {
	// 	initRandomImage();
	// 	intervalRef.current = setInterval(showNextImage, 10000);

	// 	return () => {
	// 		clearInterval(intervalRef.current);
	// 		intervalRef.current = null;
	// 	};
	// }, []);

	// const initRandomImage = () => {
	// 	const heroGridSections = Array.from(document.getElementsByClassName("hero-feature-section"));
	// 	activeIndex = generateRandomInt(0, imageTotalIndex);

	// 	for (const section of heroGridSections) {
	// 		const heroSectionImgs = section.getElementsByClassName("hero-feature-image");

	// 		for (const image of heroSectionImgs) {
	// 			const imageIndex = Array.from(heroSectionImgs).indexOf(image);

	// 			if (imageIndex === activeIndex) {
	// 				image.style.zIndex = zIndexCounter;
	// 				image.setAttribute("data-active", "true");
	// 			}
	// 		}
	// 	}

	// 	activeIndexPrev = activeIndex - 1;
	// 	zIndexCounter++;
	// };

	// const showNextImage = () => {
	// 	const heroGridSections = Array.from(document.getElementsByClassName("hero-feature-section"));
	// 	shuffleArray(heroGridSections);

	// 	for (const section of heroGridSections) {
	// 		const heroSectionImgs = section.getElementsByClassName("hero-feature-image");
	// 		const sectionIndex = Array.from(heroGridSections).indexOf(section);

	// 		for (const image of heroSectionImgs) {
	// 			const imageIndex = Array.from(heroSectionImgs).indexOf(image);
	// 			const delay = 300 * (sectionIndex + 1);

	// 			setTimeout(() => {
	// 				if (imageIndex === activeIndex) {
	// 					image.style.zIndex = zIndexCounter;
	// 					image.setAttribute("data-active", "true");
	// 				} else if (imageIndex !== activeIndexPrev) {
	// 					image.removeAttribute("data-active", "true");
	// 				}
	// 			}, delay);
	// 		}
	// 	}

	// 	activeIndexPrev = activeIndex;

	// 	if (activeIndex < imageTotalIndex) activeIndex++;
	// 	else activeIndex = 0;

	// 	zIndexCounter++;
	// };

	// const shuffleArray = (array) => {
	// 	for (let i = array.length - 1; i > 0; i--) {
	// 		const j = Math.floor(Math.random() * (i + 1));
	// 		[array[i], array[j]] = [array[j], array[i]];
	// 	}
	// };

	// const generateRandomInt = (min, max) => {
	// 	min = Math.ceil(min);
	// 	max = Math.floor(max);
	// 	return Math.floor(Math.random() * (max - min + 1)) + min;
	// };

	return (
		<section id="hero" className="grid-wrapper hero-wrapper">
			<div className="grid-wrapper padding-none hero-feature">
				{[...Array(6)].map((gridElement, idx) => (
					<div key={`hero-feature-${idx}`} aria-hidden="true" className="hero-feature-section">
						<img src={featureImg_01} alt="" className="hero-feature-image" />
						{/* <img src={featureImg_02} alt="" className="hero-feature-image" />
						<img src={featureImg_03} alt="" className="hero-feature-image" />
						<img src={featureImg_04} alt="" className="hero-feature-image" />
						<img src={featureImg_05} alt="" className="hero-feature-image" /> */}
					</div>
				))}
			</div>
			<div className="backgroundColor-kppCream hero-news">
				<NewsSlider />
			</div>
			<div className="backgroundColor-kppCream hero-about">
				<LinkImage slug={navRoutes.about} title="About" image={aboutImg} />
			</div>
			<div className="backgroundColor-kppCream hero-contact">
				<LinkImage slug={navRoutes.contact} title="Contact" image={contactImg} />
			</div>
		</section>
	);
};

export default Hero;
